import match from './match';
import pattern from './pattern';
import required from './required';
import minmax from './minmax';
import minmaxOptions from './minmax-options';

export default {
    match,
    pattern,
    required,
    minmax,
    minmaxOptions,
};
